import { Paper } from '@mui/material';
import { GridRowId } from '@mui/x-data-grid-premium';
import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import {
  NewTranslationKeys,
  fetchCustomTranslations,
  newToOldTranslationKeys,
} from '~/data/customTranslations';
import { useCustomTranslations } from '~/data/customTranslations/useCustomTranslations';
import { useLanguages } from '~/data/languages';
import { LegacyAdminList } from '~/legacy-components/LegacyAdminList';
import { getCurrentLanguage, getResources } from '~/localization';
import { AppDispatch } from '~/store';

import { TranslateDialog } from '../TranslateDialog';

import { submitTranslationData } from './data';

export const CustomTranslationList = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();
  const { languages } = useLanguages();
  const dispatch: AppDispatch = useDispatch();

  const everyTranslation = getResources();
  const englishTranslations = everyTranslation['en'].translation;
  const { customTranslations } = useCustomTranslations();
  const currentLang = getCurrentLanguage();

  const [selectedTerm, setSelectedTerm] = useState<
    NewTranslationKeys | undefined
  >(undefined);
  // const [expanded, setExpanded] = useState(false);
  const rows = Object.entries(newToOldTranslationKeys).map(
    ([newKey, oldKey]) => ({
      description: englishTranslations[oldKey] || '',
      name: customTranslations[currentLang]?.[newKey] || t(oldKey) || '',
      id: newKey,
    }),
  );

  const translateTerm = (id: GridRowId) => {
    setSelectedTerm(id as NewTranslationKeys);
  };

  const defaultData = selectedTerm
    ? languages.reduce((acc, lang) => {
        const defaultSelectedLangTranslations =
          everyTranslation?.[lang.fComLanguageCode]?.translation;
        const defaultSelectedLangTranslation =
          defaultSelectedLangTranslations[
            newToOldTranslationKeys[selectedTerm]
          ];
        return {
          ...acc,
          [lang.fComLanguageCode]:
            customTranslations[lang.fComLanguageCode]?.[selectedTerm] ||
            defaultSelectedLangTranslation ||
            t(newToOldTranslationKeys[selectedTerm]) ||
            '',
        };
      }, {})
    : undefined;
  const onSave = async (data: { [key: string]: string }) => {
    const translations = Object.entries(data)
      .filter(([transLocale, transValue]) => transValue.trim())
      .map(([transLocale, transValue]) => ({
        locale: transLocale,
        translation: transValue,
      }));
    const submitData = { term: selectedTerm, translations };
    if (selectedTerm) {
      await submitTranslationData(submitData, selectedTerm).then(() => {
        dispatch(fetchCustomTranslations());
        setSelectedTerm(undefined);
        enqueueSnackbar(t('message_success_approval'), {
          variant: 'success',
        });
      });
    }
  };

  // const ExpandIcon = expanded ? ExpandLessIcon : ExpandMoreIcon;

  return (
    <Paper sx={{ width: '100%', mt: 3 }}>
      {/* INFO: temporary commented to show on the admin page, after it's added as the rest of the Collapseble list, this can be added again */}
      {/* <Toolbar>
        <div onClick={() => setExpanded(!expanded)}>
          <Typography variant="h6" id="tableTitle" sx={{ cursor: 'pointer' }}>
            <IconButton>
              <ExpandIcon fontSize="small" />
            </IconButton>
            Custom translations
          </Typography>
        </div>
      </Toolbar>
      <Collapse in={expanded}> */}
      <LegacyAdminList rows={rows} translateTerm={translateTerm} />
      {/* </Collapse> */}
      {selectedTerm && (
        <TranslateDialog
          open={!!selectedTerm}
          onClose={() => {
            setSelectedTerm(undefined);
          }}
          languages={languages}
          defaultData={defaultData}
          onSave={onSave}
        />
      )}
    </Paper>
  );
};
